export default "__VITE_ASSET__DsRWTkdA__";